var map = {
	"./artchitecture.js": 5986,
	"./artworks.js": 745,
	"./default.js": 4841,
	"./home.js": 6549,
	"./product.js": 7545,
	"./research.js": 7585,
	"./shop.js": 6213
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6143;